import Web3 from "web3";
import cidAbi from "../abi/cidAbi";

export const address = process.env.REACT_APP_CID_ADDRESS;
export const web3 = new Web3(process.env.REACT_APP_RPC_URL);
export const contract = new web3.eth.Contract(cidAbi, address);
